import { Checkbox } from "antd";
import graphql from "utils/api/graphql";
import { useMutation, useQuery } from "@apollo/client";
import Loading from "shared/components/Loading";
import Error from "shared/components/Error";
import Container from "shared/components/Container";
import { TOKEN_TYPES } from "utils/constants";
import { isNil } from "lodash";

const Tokens = () => {
  const { data, loading, error } = useQuery(graphql.queries.TOKENS, {
    variables: {
      where: {},
    },
  });
  const [enableToken] = useMutation(graphql.mutations.ENABLE_TOKEN, {
    onCompleted: () => {},
    onError: () => {},
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const {
    tokens: { data: tokens },
  } = data;

  return (
    <Container>
      {Object.entries(TOKEN_TYPES).map(([key, value]) => {
        const token = tokens.find((token) => token.type === value.kind);
        const checked = !isNil(token) && token.enabled;
        return (
          <div
            key={key}
            style={{ display: "flex", flexDirection: "column", gap: "8px" }}
          >
            <Checkbox
              disabled={value.disabled}
              checked={checked}
              onChange={() =>
                enableToken({
                  variables: {
                    where: { type: value.type, chain: value.chain },
                    data: { enabled: !checked },
                  },
                })
              }
            >
              {value.name}
            </Checkbox>
          </div>
        );
      })}
    </Container>
  );
};

export default Tokens;
